import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './CallbackRequestForm.css';
import { Liferay } from '../common/services/liferay/liferay.js';
import api from '../common/services/liferay/api.js';
import DebugInfo from './DebugInfo.jsx';
import SuccessModal from './SuccessModal.jsx';
const CallbackRequestForm = ({requestType}) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    comment: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      // Allow empty value for clearing
      if (value === "") {
      setFormData((prev) => ({ ...prev, [name]: value }));
      return;
    }
    // Block any numbers in the input
    if (/\d/.test(value)) {
     return; // ignore input containing numbers
    }
  }
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing - only if error exists
    setErrors(prev => {
      if (prev[name]) {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      }
      return prev;
    });
  };

  const handleDateFocus = (e) => {
    // Ensure the placeholder disappears on focus
    e.target.showPicker && e.target.showPicker();
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
  };

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    } else if (/\d/.test(formData.name)) {
      // Block if there is any number in the input
      newErrors.name = 'Name cannot contain numbers';
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    // Phone validation - Mandatory; 8-15 digits; allow country code
if (!formData.phone.trim()) {
  newErrors.phone = 'Phone Number is required';
} else {
  const cleanPhone = String(formData.phone).replace(/[^\d+]/g, '').trim();
  const phoneRegex = /^\+?\d{8,15}$/;
  if (!phoneRegex.test(cleanPhone)) {
    newErrors.phone = 'Phone number must be 8-15 digits (country code optional)';
  }
}




    // Date validation
    if (!formData.date) {
      newErrors.date = 'Please pick a date';
    } else {
      const selectedDate = new Date(formData.date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (selectedDate < today) {
        newErrors.date = 'Please select a future date';
      }
    }

    // Use functional update to ensure we're working with latest state
    setErrors(() => newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const isValid = validateForm();
    if (!isValid) {
      // Errors are set by validateForm, just return
      return;
    }

    setIsSubmitting(true);
    setErrors({}); // Clear any previous errors
    
    try {
      // Submit to Liferay API
      const result = await api.createCallbackRequest(formData,requestType);
      
      // Reset form after successful submission
      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        comment: ''
      });
      
      // Show success modal
      setShowSuccessModal(true);
      
    } catch (error) {
      if (typeof process === 'undefined' || process.env?.NODE_ENV !== 'test') {
        console.error('Error submitting callback request:', error);
      }
      
      let errorMessage = 'Failed to submit callback request. Please try again.';
      
      // Handle specific error cases
      if (error.message) {
        // Prioritize auth errors even if wrapped as "API Error (Status: 401)"
        if (error.message.includes('401') || error.message.includes('403')) {
          errorMessage = 'Authentication failed. Please refresh the page and try again.';
        } else if (error.message.includes('API Error')) {
          // Keep default message for API errors
          errorMessage = 'Failed to submit callback request. Please try again.';
        } else if (error.message.includes('400')) {
          errorMessage = 'Invalid data provided. Please check your input and try again.';
        } else if (error.message.includes('500')) {
          errorMessage = 'Server error occurred. Please try again later.';
        } else {
          errorMessage = error.message;
        }
      }
      
      setErrors({ submit: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  // Disable Sundays
  const isWeekdayOrSunday = (date) => {
    const day = date.getDay(); // 0=Sunday, 6=Saturday
    const dateStr = date.toISOString().split('T')[0];
    return day !== 0;
  };
 
  // Limit time based on weekday
  // const filterTime = (time) => {
  //   const day = time.getDay();
  //   const hour = time.getHours();
  //   const minutes = time.getMinutes();
 
  //   if (day >= 1 && day <= 5) {
  //     // Mon–Fri: 8:00 AM – 5:00 PM
  //     return hour >= 8 && (hour < 17 || (hour === 17 && minutes === 0));
  //   } else if (day === 6) {
  //     // Saturday: 9:00 AM – 2:00 PM
  //     return hour >= 9 && (hour < 14 || (hour === 14 && minutes === 0));
  //   }
  //   return false; // Sunday or invalid
  // };

  // Limit time based on weekday
 const filterTime = (time) => {
  const now = new Date();
 
  const day = time.getDay();
  const hour = time.getHours();
  const minutes = time.getMinutes();
 
  // Prevent selecting past times on current day
  if (
    time.toDateString() === now.toDateString() &&
    time < now
  ) {
    return false;
  }
 
  // Mon–Fri: 8 AM – 5 PM
  if (day >= 1 && day <= 5) {
    return hour >= 8 && (hour < 17 || (hour === 17 && minutes === 0));
  }
 
  // Saturday: 9 AM – 2 PM
  if (day === 6) {
    return hour >= 9 && (hour < 14 || (hour === 14 && minutes === 0));
  }
 
  return false;
};

  return (
    <div className="callback-form-container" id="request-callback-form">
      <DebugInfo />
      <div className="callback-form-card">
        <h3 className="form-title regular text-primary-Blue-Tint-100 desk-head">Request for a callback</h3>
        <h3 className="form-title regular text-primary-background-color mob-head">Book a Free Consultation</h3>
        <form onSubmit={handleSubmit} className="callback-form">
          <div className="form-group">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Name"
              className={`form-input ${errors.name ? 'error' : ''}`}
              disabled={isSubmitting}
            />
            {errors.name && <span className="field-error">{errors.name}</span>}
          </div>

          <div className="form-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Address"
              className={`form-input ${errors.email ? 'error' : ''}`}
              disabled={isSubmitting}
            />
            {errors.email && <span className="field-error">{errors.email}</span>}
          </div>

          <div className="form-group">
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Phone Number"
              className={`form-input ${errors.phone ? 'error' : ''}`}
              pattern="^\+?[0-9]{8,15}$"
              disabled={isSubmitting}
            />
            {errors.phone && <span className="field-error">{errors.phone}</span>}
          </div>

          <div className="form-group">
           <DatePicker
    selected={formData.date ? new Date(formData.date) : null}
    onChange={(date, event) => {
      if (!date) {
        setFormData((prev) => ({ ...prev, date: '' }));
        return;
      }

      const selectedDate = new Date(date);
      const now = new Date();
      const interval = 30; // You can dynamically control this or read from a prop/timeIntervals

      // ✅ Detect if user clicked on a calendar day (not time)
      const isDateSelection =
        event &&
        event.type === 'click' &&
        event.target.classList.contains('react-datepicker__day');

      // ✅ Helper: find the first valid time for the given date
      const getFirstValidTime = (baseDate) => {
        const candidate = new Date(baseDate);
        candidate.setHours(0, 0, 0, 0);

        for (let hour = 0; hour < 24; hour++) {
          for (let minute = 0; minute < 60; minute += interval) {
            const test = new Date(candidate);
            test.setHours(hour, minute, 0, 0);
            if (filterTime(test)) return test;
          }
        }
        return null;
      };

      // ✅ Apply logic only when selecting date, not when changing time
      if (isDateSelection) {
        if (selectedDate.toDateString() === now.toDateString()) {
          // For today's date → find next available slot based on interval
          const nextSlot = new Date(now);
          const minutes = nextSlot.getMinutes();
          const nextInterval = Math.ceil(minutes / interval) * interval;
          nextSlot.setMinutes(nextInterval, 0, 0);

          if (!filterTime(nextSlot)) {
            const firstValid = getFirstValidTime(now);
            if (firstValid) {
              selectedDate.setHours(
                firstValid.getHours(),
                firstValid.getMinutes(),
                0,
                0
              );
            }
          } else {
            selectedDate.setHours(
              nextSlot.getHours(),
              nextSlot.getMinutes(),
              0,
              0
            );
          }
        } else {
          // For future dates → pick first valid time dynamically
          const firstValid = getFirstValidTime(selectedDate);
          if (firstValid) {
            selectedDate.setHours(
              firstValid.getHours(),
              firstValid.getMinutes(),
              0,
              0
            );
          }
        }
      }

      // ✅ Save as UTC ISO string (same as your original)
      setFormData((prev) => ({
        ...prev,
        date: selectedDate.toISOString(),
      }));
    }}
    showTimeSelect
    shouldCloseOnSelect={false}
    filterDate={isWeekdayOrSunday}
    filterTime={filterTime}
    minDate={new Date()}
    placeholderText="Pick a date and time"
    className={`form-input date-input ${errors.date ? 'error' : ''}`}
    disabled={isSubmitting}
    dateFormat="MM/dd/yyyy hh:mm a"
    name="date"
    onChangeRaw={(e) => e.preventDefault()} // 🔒 Prevent manual typing
    timeCaption="Time"
    showPopperArrow={false}
    timeIntervals={30} // ⬅️ Can change here; logic adjusts automatically
  />
 
            {errors.date && <span className="field-error">{errors.date}</span>}
          </div>

          <div className="form-group">
            <textarea
              name="comment"
              value={formData.comment}
              onChange={handleChange}
              placeholder="Comment"
              rows="1"
              className="form-textarea"
              disabled={isSubmitting}
            />
          </div>
            {errors.submit && (
              <div className="field-error">
                {errors.submit}
              </div>
            )}
          <button 
            type="button"
            onClick={handleSubmit}
            className="btn primary-button bold"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>
      
      <SuccessModal 
        isOpen={showSuccessModal} 
        onClose={handleCloseModal}
        title="Callback Request Submitted!"
        message="Your request has been received. One of our agents will call you back shortly."
      />
    </div>
  );
};

export default CallbackRequestForm;
